import {
  Box,
  Typography,
  TextField,
  Divider,
  MenuItem,
  Select
} from '@mui/material';
import { useState, useEffect } from 'react';

const paymentStatusList = ['RECEIVED', 'PENDING', 'NA'];

const sectionTemplate = {
  customer_name: '',
  mobile: '',
  reference_staff: '',
  from_date: '',
  to_date: '',
  doc_no: '',
  sro: '',

  payment_status_left: 'RECEIVED',
  received_payment: '',
  online_payment_left: '',
  reference_staff_left: '',
  balance_left: '',

  payment_status_right: 'PENDING',
  payment_to_receive: '',
  online_payment_right: '',
  reference_staff_right: '',
  balance_right: ''
};

const EcCcForm = ({ onChange, user, initialData }) => {

  const [form, setForm] = useState({
    meta: {
      employee_name: user?.name || '',
      emp_id: user?.id || '',
      date: new Date().toLocaleDateString()
    },

    category: 'EC_CC',
    sub_category: 'EC',

    ec: { ...sectionTemplate },
    cc: { ...sectionTemplate }
  });

  // 🔥 EDIT MODE
  useEffect(() => {
    if (initialData) {
      setForm(prev => ({
        ...prev,
        ...initialData,
        meta: {
          ...prev.meta,
          ...(initialData?.meta || {})
        },
        ec: {
          ...prev.ec,
          ...(initialData?.ec || {})
        },
        cc: {
          ...prev.cc,
          ...(initialData?.cc || {})
        }
      }));
    }
  }, [initialData]);

  // 🔥 SEND TO PARENT
  useEffect(() => {
    onChange(form);
  }, [form]);

  const updateSection = (section, key, value) => {
    setForm(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value
      }
    }));
  };

  const renderSection = (sectionKey, title) => {

  const data = form[sectionKey];

  return (
    <Box mb={5}>

      {/* 🔥 SECTION TITLE */}
      <Typography
        sx={{
          fontWeight: 700,
          mb: 2,
          color: '#0891b2'
        }}
      >
        {title}
      </Typography>

      {/* 🔥 CUSTOMER DETAILS */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 3,
          mb: 3
        }}
      >

        {/* 🔥 LEFT SIDE */}
        <Box
          sx={{
            display: 'grid',
            gap: 2
          }}
        >
          <TextField
            label="Customer Name"
            value={data.customer_name}
            onChange={(e) =>
              updateSection(sectionKey, 'customer_name', e.target.value)
            }
          />

          <TextField
            label="Mobile Number"
            value={data.mobile}
            onChange={(e) =>
              updateSection(sectionKey, 'mobile', e.target.value)
            }
          />

          <TextField
            label="Reference Staff"
            value={data.reference_staff}
            onChange={(e) =>
              updateSection(sectionKey, 'reference_staff', e.target.value)
            }
          />
        </Box>

        {/* 🔥 RIGHT SIDE */}
        <Box
          sx={{
            display: 'grid',
            gap: 2
          }}
        >

          {/* 🔥 EC */}
          {sectionKey === 'ec' && (
            <>
              <TextField
                label="From Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={data.from_date}
                onChange={(e) =>
                  updateSection(sectionKey, 'from_date', e.target.value)
                }
              />

              <TextField
                label="To Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={data.to_date}
                onChange={(e) =>
                  updateSection(sectionKey, 'to_date', e.target.value)
                }
              />

              <TextField
                label="SRO"
                value={data.sro}
                onChange={(e) =>
                  updateSection(sectionKey, 'sro', e.target.value)
                }
              />
            </>
          )}

          {/* 🔥 CC */}
          {sectionKey === 'cc' && (
            <>
              <TextField
                label="Doc No"
                value={data.doc_no}
                onChange={(e) =>
                  updateSection(sectionKey, 'doc_no', e.target.value)
                }
              />

              <TextField
                label="SRO"
                value={data.sro}
                onChange={(e) =>
                  updateSection(sectionKey, 'sro', e.target.value)
                }
              />
            </>
          )}

        </Box>

      </Box>

      {/* 🔥 PAYMENT DETAILS HEADER */}
      <Box
        sx={{
          background: '#f4f6f8',
          py: 1.5,
          px: 2,
          borderRadius: 1,
          fontWeight: 600,
          mb: 2,
          color: '#374151'
        }}
      >
        Payment Details
      </Box>

      {/* 🔥 PAYMENT DETAILS */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 3
        }}
      >

        {/* 🔥 LEFT PAYMENT */}
        <Box
          sx={{
            display: 'grid',
            gap: 2
          }}
        >

          <Select
            value={data.payment_status_left}
            onChange={(e) =>
              updateSection(sectionKey, 'payment_status_left', e.target.value)
            }
          >
            {paymentStatusList.map(p => (
              <MenuItem key={p} value={p}>{p}</MenuItem>
            ))}
          </Select>

          <TextField
            label="Received Payment"
            value={data.received_payment}
            onChange={(e) =>
              updateSection(sectionKey, 'received_payment', e.target.value)
            }
          />

          <TextField
            label="Online Payment"
            value={data.online_payment_left}
            onChange={(e) =>
              updateSection(sectionKey, 'online_payment_left', e.target.value)
            }
          />

          <TextField
            label="Reference Staff"
            value={data.reference_staff_left}
            onChange={(e) =>
              updateSection(sectionKey, 'reference_staff_left', e.target.value)
            }
          />

          <TextField
            label="Balance"
            value={data.balance_left}
            onChange={(e) =>
              updateSection(sectionKey, 'balance_left', e.target.value)
            }
          />

        </Box>

        {/* 🔥 RIGHT PAYMENT */}
        <Box
          sx={{
            display: 'grid',
            gap: 2
          }}
        >

          <Select
            value={data.payment_status_right}
            onChange={(e) =>
              updateSection(sectionKey, 'payment_status_right', e.target.value)
            }
          >
            {paymentStatusList.map(p => (
              <MenuItem key={p} value={p}>{p}</MenuItem>
            ))}
          </Select>

          <TextField
            label="Payment To Receive"
            value={data.payment_to_receive}
            onChange={(e) =>
              updateSection(sectionKey, 'payment_to_receive', e.target.value)
            }
          />

          <TextField
            label="Online Payment"
            value={data.online_payment_right}
            onChange={(e) =>
              updateSection(sectionKey, 'online_payment_right', e.target.value)
            }
          />

          <TextField
            label="Reference Staff"
            value={data.reference_staff_right}
            onChange={(e) =>
              updateSection(sectionKey, 'reference_staff_right', e.target.value)
            }
          />

          <TextField
            label="Balance"
            value={data.balance_right}
            onChange={(e) =>
              updateSection(sectionKey, 'balance_right', e.target.value)
            }
          />

        </Box>

      </Box>

    </Box>
  );
};

  return (
    <Box>

      {/* 🔥 TITLE */}
      <Typography align="center" fontWeight={700} mb={3}>
        EC / CC Expenses
      </Typography>

      {/* 🔥 HEADER */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr',
          gap: 2,
          mb: 3
        }}
      >
        <TextField
          label="Employee Name"
          value={form.meta.employee_name}
          disabled
        />

        <TextField
          label="Employee ID"
          value={form.meta.emp_id}
          disabled
        />

        <TextField
          label="Date"
          value={form.meta.date}
          disabled
        />
      </Box>

      {/* 🔥 CATEGORY */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 2,
          mb: 3
        }}
      >
        <TextField
          label="Category"
          value="EC / CC"
          disabled
        />

        <Select
          value={form.sub_category}
          onChange={(e) =>
            setForm({
              ...form,
              sub_category: e.target.value
            })
          }
        >
          <MenuItem value="EC">EC</MenuItem>
          <MenuItem value="CC">CC</MenuItem>
        </Select>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* 🔥 EC SECTION */}
      {(form.sub_category === 'EC' || form.sub_category === 'BOTH') &&
        renderSection('ec', 'EC Details')
      }

      {/* 🔥 CC SECTION */}
      {(form.sub_category === 'CC' || form.sub_category === 'BOTH') &&
        renderSection('cc', 'CC Details')
      }

    </Box>
  );
};

export default EcCcForm;